import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    FormControlLabel,
    Grid,
    Switch,
    TextField,
} from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

import DefaultApiService from "../../../../../infrastructure/api/default";
import { wrapFormikHandleChange } from "../../../../../infrastructure/utils/formatters";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";

const validationSchema = Yup.object().shape({});

const CompanyInformationModifyPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const { id: roleId } = useParams();

  const [loading, setLoading] = useState(false);

  const onNavigateToListPage = () => {
    navigate("/BI/Grid/CompanyInformation");
  };

  // Submit Action
  const onSubmit = async (formValue, { setSubmitting }) => {
    setLoading(true);
    const sendData = { ...data, ...formValue };

    try {
      const res = await DefaultApiService.modifyApi(
        "BI/Grid/CompanyInformation",
        sendData
      );

      if (res.isSuccess) {
        toast.success(res.message);
        onNavigateToListPage();
      } else {
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");

      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={
              roleId !== "create"
                ? `ویرایش ${data?.companyInformation?.date}`
                : "ایجاد"
            }
          />

          <CardContent>
            <Formik
              initialValues={data.companyInformation}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                const onMakeFormikVariable = (name) => ({
                  name: name,
                  fullWidth: true,
                  value: values[name],
                  error: errors[name] && touched[name],
                  helperText: errors[name] && touched[name] && errors[name],
                  variant: "outlined",
                });

                return (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                     
                    

                      
                      <Grid item xs={12} md={3}>
                        <TextField
                          label="نام شرکت"
                          type="string"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("companyName")}
                        />
                      </Grid>
                     
                    

                      
                      <Grid item xs={12} md={3}>
                        <TextField
                          label="استان"
                          type="string"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("state")}
                        />
                      </Grid>
                    

                      
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="آدرس"
                          type="string"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("address")}
                        />
                      </Grid>

                      
                      <Grid item xs={12} md={6} lg={4}>
                        <FormControlLabel
                          name="isOwner"
                          value={values.isOwner}
                          checked={values.isOwner}
                          onChange={wrapFormikHandleChange(handleChange)}
                          control={<Switch />}
                          label="مالک نرم افزار"
                        />
                      </Grid>

                      
                      <Grid item xs={12} md={6} lg={4}>
                        <FormControlLabel
                          name="isActive"
                          value={values.isActive}
                          checked={values.isActive}
                          onChange={wrapFormikHandleChange(handleChange)}
                          control={<Switch />}
                          label="فعال"
                        />
                      </Grid>



                      <Grid
                        item
                        xs={12}
                        md={12}
                        container
                        justifyContent={"flex-end"}
                      >
                        <Button
                          disabled={isSubmitting}
                          variant="outlined"
                          size="large"
                          color="gray"
                          sx={{ mx: 1 }}
                          onClick={onNavigateToListPage}
                        >
                          انصراف
                        </Button>

                        <Button
                          disabled={isSubmitting}
                          variant="contained"
                          type="submit"
                          size="large"
                        >
                          {loading && (
                            <CircularProgress size={16} color="inherit" />
                          )}
                          {roleId !== "create" ? "ویرایش" : "ایجاد"}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                );
              }}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CompanyInformationModifyPage;
